// Tippy.js 4.2.1 tooltip library (window.tippy global), used by zeiterfassung.js
// and vacation_calendar.js. Bundles its own popper.js v1 dependency, so it is
// self-contained (separate from Bootstrap 5's @popperjs/core v2).
import tippy from "tippy.js";

window.tippy = tippy;
